import axios from 'axios';
import { AUTH_BASE_URL } from '../constants';
import client from './client';

export interface AuthUser {
  username: string;
  role: string;
  token: string;
  permissions: string[];
}

export async function login(username: string, password: string): Promise<AuthUser> {
  try {
    const response = await axios.post(`${AUTH_BASE_URL}/authenticate`, { username, password });
    const data = response.data;
    return {
      username: data?.username || username,
      role: data?.role || '',
      token: data?.token || '',
      permissions: data?.permissions || [],
    };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message =
        error.response?.data?.message ||
        error.response?.data?.detail ||
        `Login failed with status ${error.response?.status}`;
      throw new Error(message);
    }
    throw error;
  }
}

export async function resetPassword(username: string, newPassword: string): Promise<string> {
  try {
    const response = await axios.post(`${AUTH_BASE_URL}/reset-password`, {
      username,
      new_password: newPassword,
    });
    return response.data?.message || 'Password reset successfully.';
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message ||
          error.response?.data?.detail ||
          `Password reset failed with status ${error.response?.status}`,
      );
    }
    throw error;
  }
}

export function logout() {
  return client.post('/auth/logout');
}
